import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/a32d3125-7e04-4309-beba-ae20e8cbdbd4";
export const REGISTER_URL = "https://a.ntrk2.com/fff20d47-8ca4-4f59-882f-e53054d724a8";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowcairo.kzw2a.com/download?openExternalBrowser=1&id=ahv6r3ez2pb3mf2";

export * from "./codes";
export * from "./context";
